import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Comorbidity} from '../../../../controls/agyle/ecds';
import _ from 'lodash';
import {useStylesECDS} from './ecdsStyle';
import {useSelector} from 'react-redux';
import {comorbiditis} from '../../../../store/reducers/dicts';

const PatientHistory = (props) => {
    const {t} = useTranslation();
    const classes = useStylesECDS();

    // Patient History Dataset
    const [comorbidity, setComorbidity] = useState({Comorbidity_SnomedCt: []});

    // For ReadOnly Data
    const disableData = useRef({});
    const [errorComorbidity, setErrorComorbidity] = useState(false);

    // Dictionaries
    const dictionaryComorbidity = useSelector(comorbiditis);

    useEffect(async () => {
        let data = {};
        let dataToBlock = {};
        if (props.patient?.studies?.EmergencyCare?.AttendanceOccurrence?.PatientClinicalHistory?.Comorbidity_SnomedCt) {
            const clone = _.cloneDeep(props.patient?.studies?.EmergencyCare?.AttendanceOccurrence?.PatientClinicalHistory?.Comorbidity_SnomedCt);
            let pushToArray = [];

            _.forEach(clone, element => {
                pushToArray.push(_.find(dictionaryComorbidity, {snomedCode: element}));
            });

            data = {
                Comorbidity_SnomedCt: [...pushToArray],
            };
        }

        data = {
            ...data,
            ...dataToBlock,
        };

        setComorbidity((prevState) => ({...prevState, ...data}));
        disableData.current = {...dataToBlock};
    }, []);

    useEffect(() => {
        const data = {
            Comorbidity_SnomedCt: getSnomedCode(comorbidity.Comorbidity_SnomedCt),
        };
        props.setData(data);
    }, [comorbidity]);

    const getSnomedCode = (list) => {
        let data = [];
        list.map(entry => {
            data.push(entry.snomedCode);
        });
        return data;
    };

    const multiDataHandler = (_e, val) => {
        changeHandler({
            target: {
                name: 'Comorbidity_SnomedCt',
                value: val,
            },
        });
    };

    const changeHandler = (event) => {
        const value = event.target.value;
        const check = value.some(element => !props.checkLenght(6, 18, element.snomedCode));
        setErrorComorbidity(check);
        setComorbidity((prevState) => ({...prevState, [event.target.name]: value}));
    };

    if (props.accordion !== 'Patient Clinical History') return null;

    return (
        <div className={classes.root} style={{paddingTop: 10}}>
            <Comorbidity
                name="Comorbidity_SnomedCt"
                label={t('Comorbidity')}
                error={errorComorbidity}
                value={comorbidity.Comorbidity_SnomedCt}
                onChange={multiDataHandler}
                disabled={!!disableData?.current.Comorbidity_SnomedCt}
                admitDate={props.patient?.admission?.startDate}
                noBorder={false}
                withNewBackground
                size="large"
            />
        </div>
    );
};

export default PatientHistory;
